import { publicAssetUrl } from '@wilkins-software/redwood-utils';

import {
  createExtrudedSvgThreeScene,
  type ExtrudedSvgThreeSceneHandle,
} from './extruded-svg-three-scene';

const SHELTER_SENSE_LOGO_URL = publicAssetUrl('images/shelter-sense-dog.svg');

export type ShelterSenseThreeSceneHandle = ExtrudedSvgThreeSceneHandle;

/**
 * Shelter Sense showcase mark: extruded dog SVG with brand-red rim lighting.
 * Thin wrapper around the shared enamel-pin scene factory.
 */
export async function createShelterSenseThreeScene(
  container: HTMLElement,
): Promise<ShelterSenseThreeSceneHandle | null> {
  return createExtrudedSvgThreeScene(container, {
    svgUrl: SHELTER_SENSE_LOGO_URL,
    svgViewBoxHeight: 369.9,
    logoWorldHeight: 5.4,
    // Auto-traced dog SVG has speck debris; eye ~400 SVG units².
    minShapeAreaSvgUnits: 200,
    rimLightColor: 0xc71b02,
    topRimLightColor: 0xe1d5d9,
    sideKickerColor: 0xffd4c8,
    hemisphereSkyColor: 0xfff1ec,
    hemisphereGroundColor: 0x1a0c08,
  });
}
